import { render } from "./UsefulLinks.vue?vue&type=template&id=1c883c82"
import script from "./UsefulLinks.vue?vue&type=script&lang=js"
export * from "./UsefulLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__